import React, { useState } from "react";
import Modal from "react-modal";
import DeleteIcon from "../Svgs/DeleteIcon";

const AcceptModal = ({
  isOpen,
  onClose,
  handleVerifyPayment,
  eMoney,
  setEMoney,
  acceptanceNote,
  setAcceptanceNote,
  requestDetails,
  eMoneyInputDisabled = false,
}) => {
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (eMoney <= 0) {
      setError("E-Money value must be greater than 0");
    } else {
      setError("");
      handleVerifyPayment("accept");
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Accept Request Modal"
      className={"flex-col-center"}
    >
      <div className="custom-modal shadow-lg">
        <div className="modal-header">
          <h2>Accept Request</h2>
          <button onClick={onClose}>
            <DeleteIcon />
          </button>
        </div>
        <div className="modal-content">
          <div className="row">
            <div className="col-md-8">
              <div className="form-group">
                <label>Acceptance Notes</label>
                <textarea
                  value={acceptanceNote}
                  onChange={(e) => setAcceptanceNote(e.target.value)}
                  className="form-control"
                ></textarea>
              </div>
              <div className="form-group">
                <label>Create E-Money To</label>
                <p>{requestDetails.create_emoney_to}</p>
              </div>
              <div className="form-group">
                <label>E-Money Value *</label>
                <input
                  disabled={eMoneyInputDisabled}
                  type="number"
                  value={eMoney}
                  onChange={(e) => setEMoney(e.target.value)}
                  className="form-control"
                />
                {error && <p style={{ color: "red" }}>{error}</p>}
              </div>
            </div>
            <div className="col-md-4">
              <div className="request-body  d-flex flex-column">
                <div className="request-section">
                  <h3>Registration Wallet Balance for</h3>
                  <p>{requestDetails.create_emoney_to}</p>
                  <p className="text-danger font-weight-bold">
                    {requestDetails.registration_wallet} e.m
                  </p>
                </div>

                <div className="request-section">
                  <h3>Total Direct Partners</h3>
                  <p>{requestDetails.total_direct_partners}</p>
                </div>
              </div>
              <div className="modal-footer">
                <button onClick={handleSubmit} className="btn btn-success">
                  Confirm
                </button>
                <button onClick={onClose} className="btn btn-secondary">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AcceptModal;
